<template>
  <el-row class="h-full content_block menu-management">
    <el-col :span="10" class="tree-container h-full overflow-h">
      <div style="display:flex;font-size: 18px;line-height: 40px;">
        <b style="flex:1;">菜单管理</b>
        <el-link :underline="false" type="primary" style="color: #237FFA;">
          <i class="el-icon-circle-plus-outline" circle style="font-size: 14px;" @click="handleAddRootMenu">添加根菜单</i>
        </el-link>
      </div>
      <el-input
        placeholder="输入关键字进行过滤"
        v-model.trim="filterText"
        prefix-icon="el-icon-search"
        class="margin-bottom"
      ></el-input>
      <el-tree
        :data="menuTreeData"
        :props="treeProps"
        @node-click="handleNodeClick"
        node-key="id"
        :default-expanded-keys="expandedKeys"
        :current-node-key="currentNodeKey"
        @node-expand="handleNodeExpand"
        @node-collapse="handleNodeCollapse"
        :filter-node-method="filterNode"
        ref="menuTree"
      >
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span class="custom-tree-name" :title="node.label">
            <i :class="getMenuIcon(data.type)" style="margin-right: 5px;"></i>
            {{ node.label }}
          </span>
          <span>
            <i
              class="el-icon-circle-plus-outline"
              :class="{ active: menuInfo && menuInfo.pid === data.id && currentStatus === 3 }"
              type="text"
              size="mini"
              @click.self.stop.prevent="() => handleAddChildMenu(node, data)"
              :title="'添加子菜单'"
            ></i>
            <i
              class="el-icon-edit-outline"
              type="text"
              :class="{ active: currentNodeKey === data.id && currentStatus === 2 }"
              size="mini"
              @click.self.stop.prevent="() => handleEditMenu(node, data)"
              :title="'编辑'"
            ></i>
            <i
              class="el-icon-delete"
              type="text"
              size="mini"
              :class="{ active: currentNodeKey === data.id && currentStatus === 4 }"
              @click.self.stop.prevent="() => handleDeleteMenu(node, data)"
              :title="'删除'"
            ></i>
          </span>
        </span>
      </el-tree>
    </el-col>
    <el-col :span="14" class="detail-container">
      <!-- 查看模式 -->
      <menu-detail v-if="menuInfo && [0, 1, 4].includes(currentStatus)" :menu-info="menuInfo" />
      <!-- 编辑/新增模式 -->
      <menu-form
        v-if="menuInfo && [2, 3].includes(currentStatus)"
        :menu-info="menuInfo"
        :is-edit="currentStatus === 2"
        @cancel="handleCancel"
        @save="saveMenu"
      />
    </el-col>
  </el-row>
</template>

<script>
import menuApi from '@/api/menu.js';
import MenuDetail from './components/MenuDetail.vue';
import MenuForm from './components/MenuForm.vue';

export default {
  name: 'MenuManagement',
  components: {
    MenuDetail,
    MenuForm,
  },
  data () {
    return {
      currentStatus: 0, // 状态: 0-初始化 1-查看 2-编辑 3-新增 4-删除
      menuInfo: null,
      menuTreeData: [],
      treeProps: {
        children: 'children',
        label: 'name',
      },
      filterText: '',
      currentNodeKey: '',
      expandedKeys: [],
    };
  },
  watch: {
    filterText (val) {
      this.$refs.menuTree.filter(val);
    },
  },
  mounted () {
    this.loadMenuTree();
  },
  methods: {
    // 加载菜单树
    loadMenuTree () {
      menuApi.getMenuTree().then(({body}) => {
        this.menuTreeData = body || [];
        if (this.menuTreeData.length > 0) {
          this.$nextTick(() => {
            if (!this.currentNodeKey && this.menuTreeData[0]) {
              this.currentNodeKey = this.menuTreeData[0].id;
              this.expandedKeys = [this.menuTreeData[0].id];
              this.handleNodeClick(this.menuTreeData[0]);
            }
          });
        }
      });
    },
    // 过滤节点
    filterNode (value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    // 节点点击
    handleNodeClick (menuData) {
      this.currentStatus = 1;
      this.currentNodeKey = menuData.id;
      this.menuInfo = JSON.parse(JSON.stringify(menuData));
    },
    // 节点展开
    handleNodeExpand (data) {
      if (!this.expandedKeys.includes(data.id)) {
        this.expandedKeys.push(data.id);
      }
    },
    // 节点收起
    handleNodeCollapse (data) {
      const index = this.expandedKeys.indexOf(data.id);
      if (index > -1) {
        this.expandedKeys.splice(index, 1);
      }
    },
    // 添加根菜单
    handleAddRootMenu () {
      this.currentStatus = 3;
      this.currentNodeKey = '';
      this.menuInfo = {
        name: '',
        authCode: '',
        pid: 0,
        type: 1,
        code: '',
        description: '',
        icon: '',
        menuUrl: '',
        menuUrlType: '',
        authUrl: '',
        authUrlMaster: '',
        remark: '',
        sort: 0,
        sysFlag: '',
        parentName: '根菜单',
      };
    },
    // 添加子菜单
    handleAddChildMenu (node, data) {
      this.currentStatus = 3;
      this.currentNodeKey = data.id;
      this.menuInfo = {
        name: '',
        authCode: '',
        pid: data.id,
        type: 2,
        code: '',
        description: '',
        icon: '',
        menuUrl: '',
        menuUrlType: '',
        authUrl: '',
        authUrlMaster: '',
        remark: '',
        sort: 0,
        sysFlag: '',
        parentName: data.name,
      };
    },
    // 编辑菜单
    handleEditMenu (node, data) {
      this.currentStatus = 2;
      this.currentNodeKey = data.id;
      this.menuInfo = JSON.parse(JSON.stringify(data));
      // 获取父节点名称
      if (node.parent && node.parent.data) {
        this.menuInfo.parentName = node.parent.data.name || '根菜单';
      } else {
        this.menuInfo.parentName = '根菜单';
      }
    },
    // 删除菜单
    handleDeleteMenu (node, data) {
      this.currentStatus = 4;
      this.currentNodeKey = data.id;

      // 检查是否有子节点
      if (data.children && data.children.length > 0) {
        this.$message.warning('该菜单下存在子菜单，无法删除');
        this.currentStatus = 1;
        return;
      }

      this.$confirm(`确认删除菜单【${data.name}】吗？`, '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        menuApi.deleteMenu(data.id).then(() => {
          this.$message.success('删除成功');
          this.loadMenuTree();
          this.menuInfo = null;
          this.currentNodeKey = '';
        });
      }).catch(() => {
        this.currentStatus = 1;
      });
    },
    // 取消
    handleCancel () {
      this.currentStatus = 1;
      if (this.currentNodeKey) {
        // 恢复之前的数据
        const findNode = (nodes, id) => {
          for (let node of nodes) {
            if (node.id === id) return node;
            if (node.children) {
              const found = findNode(node.children, id);
              if (found) return found;
            }
          }
          return null;
        };
        const node = findNode(this.menuTreeData, this.currentNodeKey);
        if (node) {
          this.menuInfo = JSON.parse(JSON.stringify(node));
        }
      } else {
        this.menuInfo = null;
      }
    },
    // 保存菜单
    saveMenu (params) {
      menuApi.addMenu(params).then(() => {
        this.$message.success(this.currentStatus === 2 ? '更新成功' : '新增成功');
        this.loadMenuTree();
        this.currentStatus = 1;
      });
    },
    // 获取菜单图标
    getMenuIcon (type) {
      const iconMap = {
        1: 'el-icon-folder',
        2: 'el-icon-menu',
        3: 'el-icon-s-operation',
      };
      return iconMap[type] || 'el-icon-menu';
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-management {
  .tree-container {
    padding: 20px;
    border-right: 1px solid #e8e8e8;
    overflow-y: auto;
  }

  .detail-container {
    padding: 20px;
    overflow-y: auto;
  }

  .margin-bottom {
    margin-bottom: 15px;
  }

  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;

    .custom-tree-name {
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    i {
      margin-left: 8px;
      color: #909399;
      cursor: pointer;

      &:hover {
        color: #409eff;
      }

      &.active {
        color: #409eff;
      }
    }
  }

  ::v-deep .el-tree-node__content {
    height: 36px;
  }
}
</style>
